import { motion } from "framer-motion";
import { ArrowRight, Check, Minus } from "lucide-react";
import { Reveal, SplitLines, EASE } from "./motion";

const PLANS = [
  { id: "essencial", name: "Essencial", price: "69,90", desc: "Pra colocar as primeiras páginas no ar.", features: [["Até 10 páginas", true], ["1 domínio externo", true], ["Usuários ilimitados", true], ["Visitas e leads ilimitadas", true], ["Hospedagem + SSL + CDN", true], ["Templates free", true], ["IA integrada (add-on)", true], ["Teste A/B (add-on)", false], ["Reunião de onboarding", false], ["Gestão de projetos", false]] },
  { id: "negocio", name: "Negócio", price: "99,90", popular: true, desc: "Pra quem publica toda semana e quer escalar.", features: [["Páginas ilimitadas", true], ["3 domínios externos", true], ["Usuários ilimitados", true], ["Visitas e leads ilimitadas", true], ["Hospedagem + SSL + CDN", true], ["Templates free", true], ["IA integrada (add-on)", true], ["Teste A/B (add-on)", true], ["Reunião de onboarding", false], ["Gestão de projetos", false]] },
  { id: "agencia", name: "Agência", price: "199,90", desc: "Pra quem gerencia vários clientes ao mesmo tempo.", features: [["Páginas ilimitadas", true], ["15 domínios externos", true], ["Usuários ilimitados", true], ["Visitas e leads ilimitadas", true], ["Hospedagem + SSL + CDN", true], ["Templates free", true], ["IA integrada (add-on)", true], ["Teste A/B (add-on)", true], ["Reunião de onboarding", true], ["Gestão de projetos", true]] },
];

export const Pricing = () => (
  <section id="planos" data-testid="pricing-section" className="relative py-28 sm:py-36 px-6">
    <div className="mx-auto max-w-7xl">
      <div className="grid lg:grid-cols-12 gap-8 items-end mb-16">
        <div className="lg:col-span-7">
          <Reveal y={16} className="eyebrow mb-8">Planos</Reveal>
          <SplitLines as="h2" inView className="font-display font-bold tracking-[-0.03em] leading-[1] text-4xl sm:text-5xl lg:text-6xl text-[var(--ink)]" lines={["Menos que uma", "hospedagem. Faz mais."]} />
        </div>
        <Reveal delay={0.2} className="lg:col-span-5 text-slate-600 text-base sm:text-lg leading-relaxed">
          Todos os planos com teste grátis e cancelamento a qualquer momento. Sem fidelidade, sem multa.
        </Reveal>
      </div>
      <div className="grid md:grid-cols-3 gap-5 items-stretch">
        {PLANS.map((p, i) => (
          <motion.article
            key={p.id}
            data-testid={`pricing-plan-${p.id}`}
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-10% 0px" }}
            transition={{ duration: 0.8, delay: i * 0.12, ease: EASE }}
            whileHover={{ y: -8 }}
            className={`relative rounded-[1.75rem] p-8 flex flex-col ${p.popular ? "bg-[var(--ink)] text-white shadow-2xl md:-my-4 md:py-12" : "card"}`}
          >
            {p.popular && <span data-testid="pricing-popular-badge" className="absolute top-6 right-6 rounded-full bg-[var(--orange)] text-white font-mono text-[10px] uppercase tracking-[0.2em] px-3 py-1.5">mais popular</span>}
            <h3 className="font-display font-semibold text-2xl">{p.name}</h3>
            <p className={`mt-2 text-sm ${p.popular ? "text-slate-300" : "text-slate-500"}`}>{p.desc}</p>
            <div className="mt-8 flex items-baseline gap-1">
              <span className={`text-sm font-medium ${p.popular ? "text-slate-300" : "text-slate-500"}`}>R$</span>
              <span className="font-display font-bold text-5xl tracking-tight leading-none">{p.price}</span>
              <span className={`text-sm ${p.popular ? "text-slate-400" : "text-slate-500"}`}>/mês</span>
            </div>
            <a href="/register" data-testid={`pricing-cta-${p.id}`} className={`btn mt-8 justify-center ${p.popular ? "btn-primary" : "btn-ink"}`}>
              Testar grátis <ArrowRight size={16} className="arrow" />
            </a>
            <ul className={`mt-8 flex flex-col gap-3 text-sm ${p.popular ? "text-slate-200" : "text-slate-600"}`}>
              {p.features.map(([f, ok]) => (
                <li key={f} className={`flex items-center gap-3 ${ok ? "" : "opacity-40"}`}>
                  {ok ? <Check size={16} className={p.popular ? "text-[var(--orange)]" : "text-[var(--blue)]"} /> : <Minus size={16} />}
                  {f}
                </li>
              ))}
            </ul>
          </motion.article>
        ))}
      </div>
      <Reveal delay={0.2} data-testid="guarantee-block" className="mt-14 rounded-3xl border border-[var(--orange)]/30 bg-[var(--orange)]/5 p-8 sm:p-10 grid md:grid-cols-[auto_1fr] gap-6 items-center">
        <div className="font-display font-bold text-4xl sm:text-5xl text-[var(--orange)] tracking-tight leading-none">Teste<br />grátis.</div>
        <p className="text-slate-700 text-base sm:text-lg leading-relaxed">
          Coloque sua primeira página no ar antes de pagar qualquer coisa. Se não fizer sentido, cancele com um clique — sem multa, sem e-mail pro suporte, sem drama.
        </p>
      </Reveal>
    </div>
  </section>
);
